import {
    GET_ALL_ORDERS,
    UPDATE_SELECTED_ORDER,
    CLEAR_SELECTED_ORDER,
    SET_ACTIVE_ORDER_MODAL_DIMENSIONS,
    CLEAR_ACTIVE_DELIVERY_ORDER
} from '../constants';

const INITIAL_STATE = {
    orders: [],
    order: {
        selected: null,
        highlighted: null,
        activeOrderDimensionsHeight: null,
    }
}

const ordersReducer = (state=INITIAL_STATE, action) => {
    switch(action.type){
        case GET_ALL_ORDERS: 
        return {
            ...state,
            orders: action.orders
        }
        case UPDATE_SELECTED_ORDER:
        return {
            ...state,
            order:{
                selected: action.order,
                highlighted: null,
                activeOrderDimensionsHeight: null,
            }
        }
        case CLEAR_SELECTED_ORDER:
        return {
            ...state,
            order:{
                selected: null,
                highlighted: null,
                activeOrderDimensionsHeight: null,
            }
        }
        case SET_ACTIVE_ORDER_MODAL_DIMENSIONS:
        return {
            ...state,
            order: {
                selected: state.order.selected,
                highlighted: action.order,
                activeOrderDimensionsHeight: action.height,
            }
        }
        case CLEAR_ACTIVE_DELIVERY_ORDER:
        return {
            ...state,
            order: {
                selected: state.order.selected,
                highlighted: null,
                activeOrderDimensionsHeight: null,
            }
        }
        default:
        return state
    }
}

export default ordersReducer;